import React from "react";
import { Navigate } from "react-router-dom";
import { hasAdminToken } from "../../auth/adminSession";

export default function ProtectedRoute({ children }) {
  return hasAdminToken() ? children : <Navigate to="/login" />;
}
